<template>
  <div class="textLive">
    <div class="textLive_top">
      <div class="textLive_top_title">事件</div>
      <div class="remark_c">
        <div class="remark_c_1 remark_c_item">
          <div class="remark_color"></div>
          <div class="remark_c_text">{{ props.homeTeamName }}</div>
        </div>
        <div class="remark_c_2 remark_c_item">
          <div class="remark_color"></div>
          <div class="remark_c_text">{{ props.awayTeamName }}</div>
        </div>
      </div>
    </div>
    <LoadingCom v-if="loading" class="_height" />
    <div v-if="tLiveList.length > 0">
      <div class="end_box">
        <div class="point"></div>
        <div class="end_box-text">结束</div>
      </div>
      <div class="textLive_content">
        <div v-for="(child, j) in tLiveList" :key="j">
          <div class="textLive_content_item">
            <div class="textLive_content_item_left">
              <img
                :src="getIcon(child.typeId)"
                alt=""
                v-if="props.type == 1 && getIcon(child.typeId) != ''"
              />
              <img src="@/assets/img/popUp/13.png" alt="" v-if="props.type == 2" />
            </div>

            <div
              class="textLive_content_item_right"
              :class="{
                BEB_: child.sideId == 1,
                FFD_: child.sideId == 2,
              }"
            >
              <span>{{ child.text }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="end_box start">
        <div class="point"></div>
        <div class="end_box-text">开始</div>
      </div>
    </div>
    <div class="empty _height" v-if="tLiveList.length == 0 && finished">
      <img src="@/assets/img/icon/empty.png" alt="" class="empty_img" />
      <div class="text">暂无数据</div>
    </div>
    <div class="directions" v-if="props.type == 1">
      <div class="directions_item" v-for="(item, i) in directionsList" :key="i">
        <img :src="item.icon" alt="" class="directions_item_icon" />
        <div class="directions_item_text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>
<script setup name="TextLive">
import { useRouter } from "vue-router";
import { ref, watchEffect } from "vue";
import { footballTliveList } from "@/assets/api/footBallMatch.js";
import { basketballTliveList } from "@/assets/api/basketBallMatch.js";
const props = defineProps({
  type: {
    type: Number,
    default: 1, //1:足球 2： 篮球
  },
  tabActive: {
    type: Number,
    default: 1,
  },
  awayTeamName: "",
  homeTeamName: "",
});
const finished = ref(false);
const router = useRouter();
const loading = ref(true);
const tLiveList = ref([]);
function _footballTliveList() {
  footballTliveList({ matchId: router.currentRoute.value.query.matchId })
    .then((res) => {
      loading.value = false;
      finished.value = true;
      if (!res.data) {
        return;
      }
      let result = res.data
        .map((item) => {
          return { ...item, sideId: item.side };
        })
        .reverse();

      tLiveList.value = result;
    })
    .catch(() => {
      finished.value = true;
      loading.value = false;
    });
}
function _basketballTliveList() {
  basketballTliveList({ matchId: router.currentRoute.value.query.matchId })
    .then((res) => {
      let result = res.data.reverse();
      tLiveList.value = result;
      finished.value = true;
      loading.value = false;
    })
    .catch(() => {
      finished.value = true;
      loading.value = false;
    });
}
watchEffect(() => {
  if (props.type == 1) {
    _footballTliveList();
  } else {
    _basketballTliveList();
  }
});

function getIcon(type) {
  let arr = directionsList.value.filter((item) => item.type == type);
  if (arr.length > 0) {
    return arr[0].icon;
  } else {
    return require("../../../assets/img/popUp/0.png");
  }
}
const directionsList = ref([
  {
    icon: require("../../../assets/img/popUp/0.png"),
    text: "旁白",
    type: 0,
  },
  {
    icon: require("../../../assets/img/popUp/1.png"),
    text: "进球",
    type: 1,
  },
  {
    icon: require("../../../assets/img/popUp/2.png"),
    text: "点球",
    type: 8,
  },
  {
    icon: require("../../../assets/img/popUp/3.png"),
    text: "点球未进",
    type: 16,
  },
  {
    icon: require("../../../assets/img/popUp/4.png"),
    text: "乌龙球",
    type: 17,
  },
  {
    icon: require("../../../assets/img/popUp/5.png"),
    text: "角球",
    type: 2,
  },
  {
    icon: require("../../../assets/img/popUp/6.png"),
    text: "黄牌",
    type: 3,
  },
  {
    icon: require("../../../assets/img/popUp/7.png"),
    text: "红牌",
    type: 4,
  },
  {
    icon: require("../../../assets/img/popUp/8.png"),
    text: "助攻",
    type: 18,
  },
  {
    icon: require("../../../assets/img/popUp/9.png"),
    text: "两黄一红",
    type: 15,
  },
  {
    icon: require("../../../assets/img/popUp/10.png"),
    text: "换人",
    type: 9,
  },
  {
    icon: require("../../../assets/img/popUp/11.png"),
    text: "受伤",
    type: 19,
  },
  {
    icon: require("../../../assets/img/popUp/12.png"),
    text: "VAR",
    type: 28,
  },
]);
</script>
<style scoped>
.textLive {
  margin-bottom: 10.66vw;
}
.textLive_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5.33vw;
}
.textLive_top_title {
  text-align: left;
  color: #000;
  font-family: PingFang SC;
  font-size: 4.26vw;
  font-weight: 600;
  line-height: 4.26vw;
}
.remark_c {
  display: flex;
  align-items: center;
}
.remark_c_item {
  display: flex;
  align-items: center;
  margin-left: 3.2vw;
}
.remark_color {
  width: 3.73vw;
  height: 3.73vw;
  flex-shrink: 0;
  border-radius: 1px;
  margin-right: 2px;
}
.remark_c_text {
  font-family: PingFang SC;
  font-size: 3.2vw;
  font-style: normal;
  font-weight: 400;
  line-height: 4.26vw;
  color: #000;
  opacity: 0.8;
}
.remark_c_1 .remark_color {
  background: #eceffd;
}

.remark_c_2 .remark_color {
  background: #feebeb;
}

.end_box {
  border-radius: 4vw;
  background: #ff5050;
  margin-bottom: 3.73vw;
  padding: 7px 4.53vw;
  display: flex;
  align-items: center;
}
.point {
  width: 6px;
  height: 6px;
  background-color: #fff;
  border-radius: 50%;
  margin-right: 2.66vw;
}
.end_box {
  color: #fff;
  font-family: PingFang SC;
  font-size: 3.46vw;
  font-weight: 400;
  line-height: 4.26vw;
}
.start {
  background: #49cf7f;
}
.directions {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10.66vw;
  padding-left: 5.86vw;
}
.directions_item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% / 4);
  margin-bottom: 8px;
}
.directions_item_icon {
  width: 3.73vw;
  height: 3.73vw;
  margin-right: 4px;
}
.directions_item_text {
  font-family: PingFang SC;
  font-size: 3.2vw;
  font-style: normal;
  font-weight: 400;
  line-height: 4.26vw;
  color: #9ca3af;
}

.textLive_content .textLive_content_item {
  display: flex;
  align-items: center;
  margin-bottom: 3.73vw;
}
.textLive_content_item_left {
  width: 5.33vw;
  height: 5.33vw;
  margin-right: 6px;
}
.textLive_content_item_left img {
  width: 5.33vw;
  height: 5.33vw;
}

.textLive_content_item_right {
  flex: 1;
  padding: 2.66vw 3.2vw;
  border-radius: 2.66vw;
  text-align: left;
  color: #000;
  font-size: 3.2vw;
  background: #f3f5f7;
}
.time {
  font-weight: 600;
}
.score {
  padding: 0 8px;
  display: inline-block;
}
._height {
  height: 40vh !important;
  padding: 0 !important;
}
.BEB_ {
  background: #feebeb !important;
}
.FFD_ {
  background: #eceffd !important;
}
</style>
